"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getParsedJwt = void 0;
/**
 * Returns a JS object representation of a Javascript Web Token from its common encoded
 * string form.
 *
 * @template T the expected shape of the parsed token
 * @param {string} token a Javascript Web Token in base64 encoded, `.` separated form
 * @returns {(T | undefined)} an object-representation of the token
 * or undefined if parsing failed
 */
function getParsedJwt(token) {
    try {
        return JSON.parse(atob(token.split('.')[1]));
    }
    catch (_a) {
        return undefined;
    }
}
exports.getParsedJwt = getParsedJwt;
//# sourceMappingURL=getParsedJwt.js.map